import Api from './api.service';

export default {
  getSpecialties: (params = {}) => Api.get('specialties', { params }),
};
